export const routes = [
  {
    path: '/cidade/:id/evidenciar/:pergunta',
    component: () => import(/* webpackChunkName: "evidence" */ './components/GetQuestion'),
    name: 'city.evidence.question',
    meta: {
      requiresAuth: true
    }
  }
]
